module.exports = __webpack_public_path__ + "static/media/tomato_gnocchi.ab2ecef6.JPG";